import type { OwuiChatSummary, OwuiFolder } from "@lupp/shared";

/**
 * Process-wide cache for the chat-history sidebar so it never flickers: the cached
 * content is shown instantly (even after closing/reopening or before first open),
 * while the current state is re-fetched in the background and swapped in silently.
 * A loader is only shown when something is opened for the FIRST time (nothing cached).
 */
let chatsCache: OwuiChatSummary[] | null = null;
let foldersCache: OwuiFolder[] | null = null;
const folderChatsCache = new Map<string, OwuiChatSummary[]>();

export const historyCache = {
  chats: (): OwuiChatSummary[] | null => chatsCache,
  setChats: (c: OwuiChatSummary[]): void => {
    chatsCache = c;
  },
  folders: (): OwuiFolder[] | null => foldersCache,
  setFolders: (f: OwuiFolder[]): void => {
    foldersCache = f;
  },
  folderChats: (id: string): OwuiChatSummary[] | undefined => folderChatsCache.get(id),
  setFolderChats: (id: string, c: OwuiChatSummary[]): void => {
    folderChatsCache.set(id, c);
  },
  clear: (): void => {
    chatsCache = null;
    foldersCache = null;
    folderChatsCache.clear();
  },
};
